import { render, staticRenderFns } from "./VuesticFeed.vue?vue&type=template&id=695e9432"
import script from "./VuesticFeed.vue?vue&type=script&lang=js"
export * from "./VuesticFeed.vue?vue&type=script&lang=js"
import style0 from "./VuesticFeed.vue?vue&type=style&index=0&id=695e9432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports